import { Angular5Csv } from 'angular5-csv/Angular5-csv';
import { Component, Input } from '@angular/core';

import { REPORT_OPTIONS, MOCK_DATA } from '../../constants/export.constant';

@Component({
  selector: 'export-report',
  template: `<a class="btn mr2" title="Download Report" (click)="export()">Download Report</a>`
})
export class ExportReportComponent {
  @Input() public data = MOCK_DATA;
  public options = REPORT_OPTIONS;

  public export(): void {
    new Angular5Csv(this.data, 'My Report', this.options);
  }
}
